import { mapState, mapMutations } from 'vuex'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'LabelItem',
  props: {
    index: Number
  },
  data () {
    return {
      input: {
        uuid: null,
        labelText: null
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceScreenSetting.categoryName,

      // form
      serviceId: state => state.serviceScreenSettingForm.serviceId,
      serviceContentsId: state => state.serviceScreenSettingForm.targetId,
      contentsScreenId: state => state.serviceScreenSettingForm.targetId,
      values: state => state.serviceScreenSettingForm.values,
    }),

    // validate
    formIsValid () {
      return this.validate('labelText')
    },

    // jsonb
    getJsonb () {
      return this.input
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'label',
          index: this.index,
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'serviceScreenSettingForm/setValidate'
    }),

    init () {
      let data = $.extend(true, this.input, this.values.screenLabelSettings[this.index])
      this.$set(this, 'input', data)
    },

    validate (key) {
      switch (key) {
        case 'labelText':
          return Validator.validText(this.input[key])
      }
    },
  }
}
